import { NoizeGraf } from '../NoizeGraf/NoizeGraf';
import { NoizeGraf2 } from '../NoizeGraf/NoizeGraf2';
import { NoizeValue } from '../NoizeValue/NoizeValue';
import styles from './Segment.module.css';

import avatar from '../../assets/images/avatar.jpg';

const text = `Данный текст является демонстрационным. 
Его цель – показать, как будут выглядеть строки и абзацы на готовой странице. 
Здесь нет никакой смысловой нагрузки, только равномерно повторяющиеся фразы. 
Это позволяет дизайнеру сосредоточиться на выборе шрифтов, отступов и цветового решения. 
Читатель же не должен отвлекаться на содержание, оценивая исключительно композицию. 
Такой подход помогает на раннем этапе выявить возможные недостатки вёрстки. 
Заполнитель будет заменён окончательным материалом после его утверждения. 
Объём этого текста составляет ровно сто слов, что удобно для тестирования. 
Повторяющиеся элементы создают нейтральный фон для оценки. Работа с макетом требует внимания к деталям.`;

const smallText = `Данный текст является демонстрационным. 
Его цель – показать, как будут выглядеть строки и абзацы на готовой странице.`;

const widthFull = 4620;

export const Segment = ({ left, noiseLevel, coeef }) => {
  return (
    <div
      className={styles.segment}
      style={{
        left,
        width: 53884 / coeef,
        height: 168 / coeef,
        fontSize: 100 / coeef,
      }}
    >
      {/* <div className={styles.test}>
        Заполнитель будет заменён окончательным материалом после его
        утверждения. Объём этого текста составляет ровно сто слов, что удобно
        для тестирования.
        <NoizeValue noiseLevel={noiseLevel} />
      </div> */}

      {/* <div className={styles.text}>{text}</div>
      <NoizeGraf noiseLevel={noiseLevel} />
      <NoizeValue noiseLevel={noiseLevel} /> */}

      <img
        src={avatar}
        alt=""
        className={styles.avatar}
        // style={{
        //   width: 166 / coeef,
        //   height: 166 / coeef,
        // }}
      />

      <div>{text}</div>

      {/* <NoizeGraf
        noiseLevel={noiseLevel}
        CANVAS_WIDTH={Math.round(
          (26942 - Math.round(168 / coeef) * 1.5) / coeef,
        )}
        CANVAS_HEIGHT={Math.round(120 / coeef)}
      /> */}

      <img
        src={avatar}
        alt=""
        className={styles.avatar}
        // style={{
        //   width: 166 / coeef,
        //   height: 166 / coeef,
        // }}
      />
      <img
        src={avatar}
        alt=""
        className={styles.avatar}
        // style={{
        //   width: 166 / coeef,
        //   height: 166 / coeef,
        // }}
      />

      <div
        className={styles.full}
        style={{
          backgroundColor: '#bd4646',
          width: widthFull / coeef,
        }}
      />

      <div>{smallText}</div>

      <img
        src={avatar}
        alt=""
        className={styles.avatar}
        // style={{
        //   width: 166 / coeef,
        //   height: 166 / coeef,
        // }}
      />

      <div
        className={styles.full}
        style={{
          width: widthFull / coeef,
        }}
      />

      <div>{smallText}</div>

      <div
        className={styles.full}
        style={{
          backgroundColor: '#bdb146ff',
          width: widthFull / coeef,
        }}
      />

      <img
        src={avatar}
        alt=""
        className={styles.avatar}
        // style={{
        //   width: 166 / coeef,
        //   height: 166 / coeef,
        // }}
      />

      <div>{smallText}</div>

      <div
        className={styles.full}
        style={{
          backgroundColor: '#62bd46ff',
          width: widthFull / coeef,
        }}
      />
      <img
        src={avatar}
        alt=""
        className={styles.avatar}
        // style={{
        //   width: 166 / coeef,
        //   height: 166 / coeef,
        // }}
      />

      <div>{smallText}</div>
      <div>{`------->`}</div>

      {/* <NoizeGraf2
        noiseLevel={noiseLevel}
        CANVAS_WIDTH={Math.round(
          (26942 - Math.round(168 / coeef) * 1.5) / coeef,
        )}
        CANVAS_HEIGHT={Math.round(120 / coeef)}
      /> */}

      {/* <NoizeValue noiseLevel={noiseLevel} /> */}
      {/* <NoizeGraf noiseLevel={noiseLevel} />
      <div>{text}</div> */}
    </div>
  );
};
